import { SVGProps } from 'react'

function SvgDinersclub(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={70}
      height={48}
      viewBox="0 0 70 48"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
    >
      <title>Diners Club</title>
      <path
        d="M0 6a6 6 0 0 1 6-6h58a6 6 0 0 1 6 6v36a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6Z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64 1H6a5 5 0 0 0-5 5v36a5 5 0 0 0 5 5h58a5 5 0 0 0 5-5V6a5 5 0 0 0-5-5ZM6 0a6 6 0 0 0-6 6v36a6 6 0 0 0 6 6h58a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6H6Z"
        fill="#788BA5"
      />
      <path
        d="M38.09 39C45.885 39.038 53 32.584 53 24.734c0-8.584-7.115-14.518-14.91-14.515h-6.709C23.493 10.216 17 16.15 17 24.734 17 32.586 23.493 39.037 31.381 39h6.709Z"
        fill="#0079BE"
      />
      <path
        d="M31.413 11.408c-7.208.003-13.049 5.899-13.051 13.175.002 7.276 5.843 13.172 13.051 13.174 7.21-.002 13.053-5.898 13.053-13.174s-5.842-13.172-13.053-13.175Zm-8.272 13.175a8.361 8.361 0 0 1 5.31-7.792v15.584a8.358 8.358 0 0 1-5.31-7.792Zm11.233 7.795V16.79a8.358 8.358 0 0 1 5.314 7.794 8.36 8.36 0 0 1-5.314 7.794Z"
        fill="#fff"
      />
      <path
        d="M38.09 39C45.885 39.038 53 32.584 53 24.734c0-8.584-7.115-14.518-14.91-14.515h-6.709C23.493 10.216 17 16.15 17 24.734 17 32.586 23.493 39.037 31.381 39h6.709Z"
        fill="#0079BE"
      />
      <path
        d="M31.413 11.408c-7.208.003-13.049 5.899-13.051 13.175.002 7.276 5.843 13.172 13.051 13.174 7.21-.002 13.053-5.898 13.053-13.174s-5.842-13.172-13.053-13.175Zm-8.272 13.175a8.361 8.361 0 0 1 5.31-7.792v15.584a8.358 8.358 0 0 1-5.31-7.792Zm11.233 7.795V16.79a8.358 8.358 0 0 1 5.314 7.794 8.36 8.36 0 0 1-5.314 7.794Z"
        fill="#fff"
      />
    </svg>
  )
}
export default SvgDinersclub
